import React from "react";
import { Box } from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";
export var TabsSkeleton = function (_a) {
    var children = _a.children;
    return (React.createElement(Box, null,
        React.createElement(Skeleton, { variant: "rect", height: 48 }),
        React.createElement(Box, { maxWidth: "90%", style: { margin: "auto", paddingTop: 24 } },
            React.createElement(Box, { mt: 2 }, children))));
};
